import PractitionerIds from './PractitionerIds';

export default PractitionerIds;
